import OnboardingSlide from './OnboardingSlide';
import TasksDemoAnimation from './TasksDemoAnimation';

export default function SlideTasks() {
  return (
    <OnboardingSlide
      illustration={<TasksDemoAnimation />}
      title="Tasks & Flow Sheet"
    >
      <p>
        Open any patient to see their <strong>task list</strong> and <strong>flow sheet</strong>.
      </p>
      <p className="font-medium text-gray-700">Task types:</p>
      <ul className="list-inside list-disc space-y-1 text-xs">
        <li>
          <strong>Voice-enabled</strong> (mic icon) — tap to record and complete, e.g. vitals, progress
          notes, MAR.
        </li>
        <li>
          <strong>Manual</strong> (checkbox) — tap to check off, e.g. repositioning, wound care.
        </li>
        <li>
          <strong>Generated follow-ups</strong> — created from your notes, e.g. &ldquo;Reassess pain in
          2 hours.&rdquo;
        </li>
      </ul>
      <p className="font-medium text-gray-700">Status:</p>
      <ul className="list-inside list-disc space-y-0.5 text-xs">
        <li>
          <strong>Pending</strong> — due soon · <strong>Overdue</strong> — past due ·{' '}
          <strong>Completed</strong> — done this shift
        </li>
      </ul>
      <p>
        The <strong>Flow Sheet</strong> tab shows vitals trends, fluid balance, medications, and
        observations — print it anytime from the patient screen.
      </p>
    </OnboardingSlide>
  );
}
